module.exports = __webpack_public_path__ + "img/inco5Ac.eeef2efc.png";